export interface Panel {
  id: string;
  type: string;
  ratio: number;
  collapsed: boolean;
  config: any;
  style?: Record<string, string>;
}
